import { Story } from "../editorial/types";
export type Category = "perspectives" | "voices" | "judges" | "industry";
export const CATEGORIES: { key: Category; label: string; blurb: string }[] = [
  { key: "perspectives", label: "Scientific Perspectives", blurb: "Scientific questions, viewpoints and discussion." },
  { key: "voices", label: "iDEC Voices", blurb: "Competition retrospectives, community stories, organisers and participants." },
  { key: "judges", label: "Judges’ Perspectives", blurb: "Judges’ views, research assessment and advice. Personal opinions, not official results." },
  { key: "industry", label: "Industry Insights", blurb: "Industry progress, tools and applications. Sponsored pieces state their source or commercial relationship." },
];
export const categoryLabel = (k: string) => CATEGORIES.find((c) => c.key === k)?.label || "";
export type ArticleFields = {
  slug: string;
  title: string;
  standfirst: string;
  category: Category;
  authorName: string;
  authorRole: string;
  authorBio: string;
  authorPhotoUrl: string;
  authorPhotoAlt: string;
  coverUrl: string;
  coverAlt: string;
  coverCaption: string;
  bodyMarkdown: string;
  projectId: string;
  rightsNote: string;
};
export type Author = {
  name: string;
  role: string;
  bio: string;
  photoUrl: string;
  photoAlt: string;
  initials: string;
};
export type ArticleSummary = {
  id: string;
  slug: string;
  url: string;
  title: string;
  standfirst: string;
  category: Category;
  categoryLabel: string;
  categoryUrl: string;
  author: Author;
  cover: null | { url: string; alt: string; caption: string };
  publishedAt: string | null;
  project: Story | null;
};
export type Article = ArticleSummary & { bodyMarkdown: string };
export type BlogHomeData = {
  lead: ArticleSummary | null;
  supporting: ArticleSummary[];
  latest: { key: Category; label: string; url: string; item: ArticleSummary | null }[];
  more: ArticleSummary[];
  sections: { key: Category; label: string; url: string; items: ArticleSummary[]; total: number }[];
  total: number;
};
export type AdminArticle = {
  id: string;
  draft: ArticleFields;
  published: ArticleFields | null;
  revision: number;
  publishedRevision: number | null;
  canonicalSlug: string | null;
  createdAt: string;
  updatedAt: string;
  publishedAt: string | null;
};
export const LIMITS = {
  title: 220,
  standfirst: 600,
  authorName: 160,
  authorRole: 160,
  authorBio: 1000,
  authorPhotoAlt: 240,
  coverAlt: 240,
  coverCaption: 240,
  bodyMarkdown: 60000,
  rightsNote: 1000,
};
